// src/pages/Svetila.tsx
import CategoryPage from './CategoryPage';

const Svetila = () => {
  const subcategories = [
    {
      title: "Index Support Lights",
      imageSrc: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&q=80",
      url: "/svetila/index-support"
    },
    {
      title: "Turareg Ceiling Lights",
      imageSrc: "https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?auto=format&fit=crop&q=80",
      url: "/svetila/turareg-ceiling"
    },
    {
      title: "Index Ceiling Lights",
      imageSrc: "https://images.unsplash.com/photo-1544965838-54ef8406f868?auto=format&fit=crop&q=80",
      url: "/svetila/index-ceiling"
    }
  ];

  return (
    <CategoryPage
      title="Svetila"
      description="Razsvetlite vašo kopalnico z našo elegantno kolekcijo svetil, ki ustvarjajo popolno ambientalno osvetlitev."
      heroImage="https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?auto=format&fit=crop&q=80"
      subcategories={subcategories}
    />
  );
};

export default Svetila;